import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import text from "../../Text/text.json"

export default function WarningText() {
    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                    mt: 3,
                    maxWidth: "650px",
                    mx: "auto",
                    px: { xs: 1, md: 0 },
                }}
            >
                <InfoOutlinedIcon
                    sx={{
                        color: "#f5840b",
                        fontSize: "18px",
                        mt: "2px",
                        fontWeight: "bold",
                    }}
                />

                <Typography
                    className="font-helviteca text-blue-80"
                    sx={{
                        fontSize: "12px",
                        color: "#7D8DA6",
                        lineHeight: "16px",
                    }}
                >
                    {text.warning.message}
                </Typography>
            </Box>
        </>
    );
}